import React from 'react';
import { useSelector } from 'react-redux';

import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { Header } from '@swf/core/enums';
import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import { TryAgainMessage } from '@swf/sports/components';

import MeetingGroups from './components/MeetingGroups/MeetingGroups';
import {
  sportsAnimalRacingMeetingsWidgetModel,
  useSportsAnimalRacingMeetingsWidget
} from './model';

const SportsAnimalRacingMeetingsWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsAnimalRacingMeetingsWidget();
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const errorCode = useSelector(widgetSelect.errorCode);

  if (isLoading && !hasPreloaded) {
    return null;
  }

  if (typeof errorCode !== 'undefined') {
    return <TryAgainMessage />;
  }

  return (
    <>
      <Vary by={[Header.TimeZone]} />
      <MeetingGroups />
    </>
  );
};

SportsAnimalRacingMeetingsWidget.model = sportsAnimalRacingMeetingsWidgetModel;

export default withWidgetTestId(SportsAnimalRacingMeetingsWidget, 'sports-animal-racing-meetings');
